import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getCatalog = createAsyncThunk('catalog/getCatalog', async (categoryParams) => {
    try {
        let config = {
          headers: AuthHeader.authHeader(),
          params: {
            range: JSON.stringify([categoryParams[1], categoryParams[2]]),
            categoryId: categoryParams[0],
            priceFilter: categoryParams[3]
          },
        }
      
        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog", config );
        console.log("CATALOG RESPONSE" , response.data);
        for(var i=0; i<response.data.data.length; i++) {
          console.log("CATALOG RESPONSE" , i, response.data.data[i].colors);
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        console.log("CATALOG RESPONSE2" , response);
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const getIgniteProducts = createAsyncThunk('catalog/getIgniteProducts', async () => {
    try {
        let config = {
          headers: AuthHeader.authHeader()
        }
      
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/igniteproducts", config );
        console.log("CATALOG RESPONSE" , response.data);
        for(var i=0; i<response.data.data.length; i++) {
          console.log("CATALOG RESPONSE" , i, response.data.data[i].colors);
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        console.log("CATALOG RESPONSE2" , response);
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const getAdminCatalog = createAsyncThunk('catalog/getAdminCatalog', async (categoryParams) => {
    try {
        let config = {
          headers: AuthHeader.authHeader(),
          params: {
            range: JSON.stringify([categoryParams[1], categoryParams[2]])
          },
        }
      
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/allcatalog/category/" + categoryParams[0], config );
        for(var i=0; i<response.data.data.length; i++) {
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        console.log("CATALOG RESPONSE2" , response);
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const searchCatalog = createAsyncThunk('catalog/searchCatalog', async (search) => {
    try {
      console.log("SEARCH TERMS", search);
      let config = {
          headers: AuthHeader.authHeader(),
          params: {
            searchTerm: search[0],
            range: JSON.stringify([search[1], search[2]])
          },
        }

        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/search/all", config );
        for(var i=0; i<response.data.data.length; i++) {
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const getFeatured = createAsyncThunk('catalog/getFeatured', async () => {
    console.log("GET FEATURED");
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/featured", { headers: AuthHeader.authHeader()});
        for(var i=0; i<response.data.data.length; i++) {
          response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
        }
        console.log("CATALOG FEATURED RESPONSE" , response);
        /*for(var i=0; i<response.data.data.length; i++) {
          response.data.data[0].colors = JSON.parse(response.data.data[i].colors);
        }*/
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const selectAllCatalogItems = state => state.catalog;
  export const selectAllIgniteProducts = state => state.catalog.igniteProducts;
  export const allFeatured = state => state.catalog.featured;
  export const selectCatalogItem = state => state.catalog.currentItem;
  export const selectCurrentNewHireKitItems = state => state.catalog.currentNewHireKitItems;
  export const selectDecorations = state => state.catalog.currentDecorations;
  export const selectInventory = state => state.catalog.inventory;
  export const selectOtherCatalogItems = state => state.catalog.otherProducts;
  export const catalogTotalCount = state => state.catalog.catalogTotalCount;
  export const selectStyle = state => state.catalog.style;

  export const getCatalogItem = createAsyncThunk('catalog/getCatalogItem', async (itemId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/item/" + itemId, { headers: AuthHeader.authHeader()});

        for(var i=0; i<response.data.items.length; i++) {
          response.data.items[i].sizes = JSON.parse(response.data.items[i].sizes);
          response.data.items[i].sizes.sort(function compareFn(a, b) {
            if (a.order < b.order ) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
        }
        
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const getAdminCatalogItem = createAsyncThunk('catalog/getAdminCatalogItem', async (itemId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/catalog/item/" + itemId, { headers: AuthHeader.authHeader()});
        for(var i=0; i<response.data.item.length; i++) {
          console.log("SIZES", JSON.parse(response.data.item[i].sizes));
          response.data.item[i].sizes = JSON.parse(response.data.item[i].sizes);
          response.data.item[i].sizes.sort(function compareFn(a, b) {
            if (a.order < b.order ) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
        }
        console.log("OTHER SIZES", response.data.otherProducts);
        for(i=0; i<response.data.otherProducts.length; i++) {
          console.log("OTHER SIZES", JSON.parse(response.data.otherProducts[i].sizes));
          response.data.otherProducts[i].sizes = JSON.parse(response.data.otherProducts[i].sizes);
          response.data.otherProducts[i].sizes.sort(function compareFn(a, b) {
            if (a.order < b.order ) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
        }
        console.log("ITEM IN REDUCER", response.data);
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const getNewHireKitItems = createAsyncThunk('catalog/getNewHireKitItems', async (itemId) => {
    try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/newhirekititems", { headers: AuthHeader.authHeader()});
        for(var i=0; i<response.data.items.length; i++) {
          console.log("SIZES", JSON.parse(response.data.items[i].sizes));
          response.data.items[i].sizes = JSON.parse(response.data.items[i].sizes);
          response.data.items[i].sizes.sort(function compareFn(a, b) {
            if (a.order < b.order ) {
              return -1;
            }
            if (a.order > b.order) {
              return 1;
            }
            // a must be equal to b
            return 0;
          });
        }
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  export const addColor = createAsyncThunk('catalog/addColor', async (productIds) => {
    try {
        const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/catalog/addcolors/", 
        { productIds: productIds },
        { headers: AuthHeader.authHeader()});
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });

  const initialState = {
    catalog: [],
    igniteProducts: [],
    catalogTotalCount: 0,
    featured: [],
    currentNewHireKitItems: [],
    currentItem: [],
    currentDecorations: [],
    otherProducts: [],
    status: 'idle',
    featuredStatus: 'idle',
    itemStatus: 'idle',
    adminItemStatus: 'idle',
    adminCatalogStatus: 'idle',
    error: null,
    style: {}

  };

  const catalogSlice = createSlice({
    name: 'catalog',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
          .addCase(getCatalog.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getCatalog.fulfilled, (state, action) => {
            state.status = 'succeeded'
            // Add any fetched posts to the array
            console.log("ADD TO CATALOG ARRAY", action.payload.data);
            state.catalog = action.payload.data;
            state.catalogTotalCount = action.payload.count;
            console.log("ADD TO CATALOG ARRAY", state.catalog);

          })
          .addCase(getCatalog.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(getIgniteProducts.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getIgniteProducts.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.igniteProducts = action.payload.data;
            console.log("ADD TO IGNITE PRODUCTS ARRAY", state.igniteProducts);
          })
          .addCase(getIgniteProducts.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(getAdminCatalog.pending, (state, action) => {
            state.adminCatalogStatus = 'loading'
          })
          .addCase(getAdminCatalog.fulfilled, (state, action) => {
            state.adminCatalogStatus = 'succeeded'
            state.catalog = action.payload.data;
            state.catalogTotalCount = action.payload.count;
          })
          .addCase(getAdminCatalog.rejected, (state, action) => {
            state.adminCatalogStatus = 'failed'
            state.error = action.error.message
          })
          .addCase(searchCatalog.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(searchCatalog.fulfilled, (state, action) => {
            state.status = 'succeeded'
            // Add any fetched posts to the array
            console.log("ADD TO CATALOG ARRAY", action.payload.data);
            state.catalog = action.payload.data;
            state.catalogTotalCount = action.payload.count;
            console.log("ADD TO CATALOG ARRAY", state.catalog);

          })
          .addCase(searchCatalog.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
          })
          .addCase(getFeatured.pending, (state, action) => {
            state.featuredStatus = 'loading';
          })
          .addCase(getFeatured.fulfilled, (state, action) => {
            state.featuredStatus = 'succeeded';
            console.log("ACTION PAYLOAD", action.payload);
            state.featured = action.payload.data;
          })
          .addCase(getFeatured.rejected, (state, action) => {
            state.featuredStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(getCatalogItem.pending, (state, action) => {
            state.itemStatus = 'loading';
          })
          .addCase(getCatalogItem.fulfilled, (state, action) => {
            state.itemStatus = 'succeeded';
            // Add any fetched posts to the array
            state.currentItem = action.payload;
            state.inventory = action.payload.inventory;
          })
          .addCase(getCatalogItem.rejected, (state, action) => {
            state.itemStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(getAdminCatalogItem.pending, (state, action) => {
            state.adminItemStatus = 'loading';
          })
          .addCase(getAdminCatalogItem.fulfilled, (state, action) => {
            state.adminItemStatus = 'succeeded';
            // Add any fetched posts to the array
            console.log("ITEM IN REDUCER", action.payload);
            state.currentItem = action.payload.item;
            state.currentDecorations = action.payload.decorations;
            state.otherProducts = action.payload.otherProducts;
            state.inventory = action.payload.inventory;
            state.style = action.payload.style;

          })
          .addCase(getAdminCatalogItem.rejected, (state, action) => {
            state.adminItemStatus = 'failed';
            state.error = action.error.message;
          })
          .addCase(getNewHireKitItems.pending, (state, action) => {
            state.adminItemStatus = 'loading';
          })
          .addCase(getNewHireKitItems.fulfilled, (state, action) => {
            state.adminItemStatus = 'succeeded';
            // Add any fetched posts to the array
            console.log("ITEM IN REDUCER", action.payload);
            state.currentNewHireKitItems = {};
            state.currentNewHireKitItems.items = action.payload.items;
            state.inventory = action.payload.inventory;
          })
          .addCase(getNewHireKitItems.rejected, (state, action) => {
            state.adminItemStatus = 'failed';
            state.error = action.error.message;
          })

      }
  });
  
  export default catalogSlice.reducer;


